import { render } from "./TrekDetails.vue?vue&type=template&id=58b282f8&scoped=true"
import script from "./TrekDetails.vue?vue&type=script&lang=js"
export * from "./TrekDetails.vue?vue&type=script&lang=js"

import "./TrekDetails.vue?vue&type=style&index=0&id=58b282f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b282f8"]])

export default __exports__